import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "@/components/Layout";
import { Logo } from "@/components/Logo";
import { GoogleLogo } from "@phosphor-icons/react";

export default function Login() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleGoogleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout noFooter>
      <div className="min-h-[calc(100vh-4rem)] grid md:grid-cols-2">
        {/* LEFT — image */}
        <div
          className="hidden md:block relative bg-cover bg-center as-grain"
          style={{
            backgroundImage:
              'url("https://images.unsplash.com/photo-1544021601-3e5723f9d333?crop=entropy&cs=srgb&fm=jpg&q=85&w=1500")',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-as-black/60 via-as-black/40 to-as-black/90" />
          <div className="absolute bottom-12 left-12 right-12">
            <p className="as-label text-as-green mb-3">{t("login.left_label")}</p>
            <h2 className="as-heading text-5xl text-white">
              {t("login.left_headline_1")}<br /> <span className="text-as-green">{t("login.left_headline_2")}</span>
            </h2>
          </div>
        </div>

        {/* RIGHT — form */}
        <div className="flex items-center justify-center p-8 sm:p-16 bg-as-black">
          <div className="w-full max-w-md">
            <Logo size="md" className="mb-12 mx-auto" />
            <p className="as-label text-as-green mb-3">{t("login.form_label")}</p>
            <h1 className="as-heading text-4xl text-white mb-3">{t("login.form_title")}</h1>
            <p className="text-sm text-as-gray mb-10">
              {t("login.form_subtitle")}
            </p>

            <button
              onClick={handleGoogleLogin}
              className="w-full bg-white text-as-black font-bold uppercase tracking-widest py-4 px-6 flex items-center justify-center gap-3 hover:bg-as-green hover:-translate-y-0.5 transition-all"
              data-testid="google-login-btn"
            >
              <GoogleLogo size={22} weight="bold" />
              {t("login.google_button")}
            </button>

            <p className="text-xs text-as-gray-dim mt-8 text-center">
              {t("login.terms_notice")}
            </p>

            <button
              onClick={() => navigate("/")}
              className="w-full mt-8 as-label hover:text-as-green transition-colors"
              data-testid="back-home"
            >
              ← {t("common.back_home")}
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
